import React from "react";
import { Switch, Route } from "react-router-dom";
import { hot } from 'react-hot-loader';
import AuthLayout from "layout/AuthLayout";
import AppLayout from "layout/AppLayout";
import AdgangurBannadur from "../../pages/adgangur-bannadur/AdgangurBannadur";
import PrivateRoute from "../auth/PrivateRoute";
import "./App.css";



function App() {
  return <div className="App">
    <Switch>
          <Route path="/innskraning" component={AuthLayout} />
          <Route path="/adgangur-bannadur" component={AdgangurBannadur} />
      <PrivateRoute path="/" component={AppLayout} />
    </Switch>
  </div>
}

export default hot(module)(App);